import palette from '@/utils/palette';

export default function getRandomColor() {
  return palette[Math.floor(Math.random() * palette.length)];
}
